// Smaller Custom Styled Components used throughout the portfolio
import styled from 'styled-components';

export const Emphasis = styled.span`
	color: var(--emphasis-color);
`;

export const Primary = styled.span`
	color: var(--primary-color);
`;
